module.exports = function () {
  this.app.$on('updatePickupType', event => {
    if (typeof event.isUS !== 'undefined') {
      if (event.isUS) {
        if (this.app.leg1.pickupHasAirline && !!this.app.leg1.pickupTypes.MeetAndGreet === false) {
          this.app.leg1.pickupType = this.app.leg1.pickupTypes.Curbside.label
          this.app.leg1.pickupFee = this.app.leg1.pickupTypes.Curbside.fee
        }
        if (!!this.app.leg2 === true && this.app.leg2.pickupHasAirline && !!this.app.leg2.pickupTypes.MeetAndGreet === false) {
          this.app.leg2.pickupType = this.app.leg2.pickupTypes.Curbside.label
          this.app.leg2.pickupFee = this.app.leg2.pickupTypes.Curbside.fee
        }
      } else {
        if (this.app.leg1.pickupHasAirline) {
          if (this.app.leg1.serviceType === 'shared') {
            this.app.leg1.pickupType = 'MeetAndGreet'
            this.app.leg1.pickupFee = this.app.leg1.pickupTypes.MeetAndGreet.fee
          } else {
            this.app.leg1.pickupType = 'Curbside'
            this.app.leg1.pickupFee = 0
          }
        }
        if (this.app.leg2 && this.app.leg2.pickupHasAirline) {
          if (this.app.leg2.serviceType === 'shared') {
            this.app.leg2.pickupType = 'MeetAndGreet'
            this.app.leg2.pickupFee = this.app.leg2.pickupTypes.MeetAndGreet.fee
          } else {
            this.app.leg2.pickupType = 'Curbside'
            this.app.leg2.pickupFee = 0
          }
        }
      }

      if (this.app.leg1.pickupHasAirline) {
        this.app.$emit('mobileCCUpdate', {
          isUS: event.isUS,
          pickupType: this.app.leg1.pickupType,
          fee: this.app.leg1.pickupFee
        })
      }
      if (this.app.leg2 && this.app.leg2.pickupHasAirline) {
        this.app.$emit('mobileCCUpdate', {
          isUS: event.isUS,
          pickupType: this.app.leg2.pickupType,
          fee: this.app.leg2.pickupFee
        })
      }
      return
    }

    if (event.leg === 'leg1') {
      this.app.leg1.pickupType = event.pickupType
      this.app.leg1.pickupFee = event.pickupFee
    } else if (event.leg === 'leg2' && event.pickupType !== '') {
      this.app.leg2.pickupType = event.pickupType
      this.app.leg2.pickupFee = event.pickupFee
    }
  })
}



// WEBPACK FOOTER //
// ./src/events/reservation-details.js